import React, { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import client from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import ProductCard from "@/components/ProductCard";
import { toast } from "sonner";

export function Wishlist() {
    const { user, loading } = useAuth();
    const [items, setItems] = useState([]);
    const [busy, setBusy] = useState(true);
    const load = () => client.get("/wishlist").then(r => { setItems(r.data); setBusy(false); });
    useEffect(() => { if (user) load(); else if (!loading) setBusy(false); }, [user, loading]);

    if (loading) return null;
    if (!user) return (
        <div className="max-w-2xl mx-auto py-24 text-center px-6">
            <h1 className="font-serif-luxe text-4xl mb-4">Your Wishlist</h1>
            <p className="text-[color:var(--muted-brown)] mb-6">Please login to save and view your favourite pieces.</p>
            <div className="flex gap-3 justify-center"><Link to="/login" className="btn-primary">Login</Link><Link to="/register" className="btn-outline">Register</Link></div>
        </div>
    );

    return (
        <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-14">
            <div className="text-center mb-10">
                <div className="eyebrow">Saved For You</div>
                <h1 className="font-serif-luxe text-5xl mt-3">My Wishlist</h1>
            </div>
            {busy ? <div className="text-center">Loading…</div> :
              items.length === 0 ? <div className="text-center py-16 text-[color:var(--muted-brown)]">No favourites yet. Explore the catalogue and add pieces you love.</div> :
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
                  {items.map(p => <ProductCard key={p.id} product={p} onWishlistChange={load} />)}
              </div>
            }
        </div>
    );
}

export function Account() {
    const { user, logout, loading } = useAuth();
    if (loading) return null;
    if (!user) return <Navigate to="/login" replace />;
    return (
        <div className="max-w-3xl mx-auto px-6 py-16">
            <div className="text-center mb-10">
                <div className="eyebrow">Welcome</div>
                <h1 className="font-serif-luxe text-5xl mt-3">{user.name}</h1>
            </div>
            <div className="card-luxe p-8 space-y-4">
                <div><div className="eyebrow text-[color:var(--muted-brown)]">Email</div><div className="mt-1">{user.email}</div></div>
                {user.phone && <div><div className="eyebrow text-[color:var(--muted-brown)]">Phone</div><div className="mt-1">{user.phone}</div></div>}
                <div className="pt-4 flex gap-3">
                    <Link to="/wishlist" className="btn-outline">My Wishlist</Link>
                    <button onClick={logout} className="btn-primary">Logout</button>
                </div>
            </div>
        </div>
    );
}
